export enum UpdateProfileActionTypes {
  UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST',
  UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS',
  UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE',
  UPDATE_PROFILE_RESET_ERROR = 'UPDATE_PROFILE_RESET_ERROR',
  UPDATE_PROFILE_RESET = 'UPDATE_PROFILE_RESET',
  UPDATE_PROFILE_FIELDS = 'UPDATE_PROFILE_FIELDS',
}

export interface PersonalData {
  pin: string;
  documentNumber: string;
  front: string;
  back: string;
  selfie: string;
}

export interface UpdateProfileInput {
  id: string;
  identificationData: Partial<PersonalData>;
}

export interface UpdateProfileRequest {
  type: UpdateProfileActionTypes.UPDATE_PROFILE_REQUEST;
  input: UpdateProfileInput;
}

export interface UpdateProfileSuccess {
  type: UpdateProfileActionTypes.UPDATE_PROFILE_SUCCESS;
}

export interface UpdateProfileFailure {
  type: UpdateProfileActionTypes.UPDATE_PROFILE_FAILURE;
  error: Error;
}

export interface UpdateProfileResetError {
  type: UpdateProfileActionTypes.UPDATE_PROFILE_RESET_ERROR;
}

export interface UpdateProfileReset {
  type: UpdateProfileActionTypes.UPDATE_PROFILE_RESET;
}

export type ImageField = 'front' | 'back' | 'selfie';

export type PersonalDataErrors = Partial<Record<keyof PersonalData, string>>;

export interface UpdateProfileFields {
  type: UpdateProfileActionTypes.UPDATE_PROFILE_FIELDS;
  fields: Partial<PersonalData>;
}

export type UpdateProfileActions =
  | UpdateProfileRequest
  | UpdateProfileSuccess
  | UpdateProfileFailure
  | UpdateProfileResetError
  | UpdateProfileReset
  | UpdateProfileFields;
